import { useQueries, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { type ApiPrice } from './prices.type';
import { fetchRequest, usePrepareRequest } from './helpers';
import { PRICES } from './constants';

export const SERVICE_GRID_ID = 423;
export const NO_SIZE_GRID_ID = 254;

const useFetchPrice = () => {
  const { headers, endpoint } = usePrepareRequest({ serviceApi: PRICES });
  const fetchPrice = (storeId: number, priceArticleId: number | undefined) => {
    return priceArticleId === undefined
      ? Promise.resolve([])
      : fetchRequest<ApiPrice[]>({
          headers,
          url: `${endpoint}?${new URLSearchParams({ storeId: String(storeId), articleIds: String(priceArticleId) })}`,
        });
  };
  return { fetchPrice };
};

export function useGetPriceQuery(priceArticleId: number | undefined, storeId: number, { enabled = true } = {}) {
  const { fetchPrice } = useFetchPrice();
  const queryKey = ['prices', priceArticleId, storeId];

  return useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchPrice(storeId, priceArticleId),
    select(data) {
      return data.at(0);
    },
    staleTime: Infinity,
  });
}

export const useGetPricesQueries = (priceArticleIds: number[], storeId: number, docNumber?: string) => {
  const { fetchPrice } = useFetchPrice();
  const priceArticleIdsCleaned = [...new Set(priceArticleIds)];

  return useQueries({
    queries: priceArticleIdsCleaned.map(priceArticleId => ({
      enabled: !docNumber,
      queryKey: ['prices', priceArticleId, storeId],
      queryFn: () => fetchPrice(storeId, priceArticleId),
      select(data: ApiPrice[]) {
        return data.at(0);
      },
      staleTime: Infinity,
    })),
  });
};

export const useIsPriceOk = (priceArticleId: number | undefined, storeId: number) => {
  const [priceState, setPriceState] = useState<boolean>(true);
  const query = useGetPriceQuery(priceArticleId, storeId, { enabled: false });

  useEffect(() => {
    setPriceState(!query.isError);
  }, [query]);

  return priceState;
};
